/**
 * @packageDocumentation
 * @module f1/to
 */

import is_string from '../is/is_string';

export interface ToRegExp {
  /**
   * Convert a string or regular expression to a regular expression
   *
   * @public
   * @function f1.to.regExp
   * @example
   *
   * ```ts
   * f1.to.regExp(/a/) === /a/
   * f1.to.regExp('a') === /a/
   * ```
   */
  (regExp: RegExp | string): RegExp;
}

/**
 * @see ToRegExp
 */
export default (regExp: RegExp | string): RegExp => {
  return is_string(regExp) ? new RegExp(regExp) : regExp;
};
